import React from 'react';
import { Button } from '../../shared';
import './back-button.scss';
export var BackButton = function (_a) {
    var type = _a.type, variant = _a.variant, onClick = _a.onClick, width = _a.width, visibility = _a.visibility;
    return (React.createElement("div", { className: "back-button ".concat(visibility ? '' : 'back-button__display-btn') },
        React.createElement(Button, { type: type, variant: variant, onClick: onClick, icon: "chevronLeft", iconPosition: "left", childClasses: "u-flex__align-right" }, "back")));
};
